import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./utils/axios";
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import SlideVerify from 'vue-monoplasty-slide-verify'
import './assets/font_51h40t11p92/iconfont.css'

Vue.use(SlideVerify)
Vue.use(ElementUI);
Vue.use(UmyUi);

Vue.config.productionTip = false
Vue.prototype.$praseStrEmpty = function(str) {
  if (typeof str === 'undefined' || str === null) {
      return "";
  }
  return str;
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
const resizeObserverErr = 'ResizeObserver loop completed with undelivered notifications.'
window.addEventListener('error', e => {
  if (e.message === resizeObserverErr) {
    e.stopImmediatePropagation()
    return false
  }
})
window.addEventListener('unhandledrejection', e => {
  if (e.reason?.message === resizeObserverErr) {
    e.stopImmediatePropagation()
    return false
  }
})
const debounce = (fn, delay) => {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

window.addEventListener('error', (e) => {
  if (e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});

// 覆盖ResizeObserver 原生方法防抖
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 20);
    super(callback);
  }
};
